export const isTrueImage = value => {
  if (!value) {
    return true
  }
  if (typeof value === 'string') {
    return true
  }
  return value.type.startsWith('image')
}

export const isValidImageSize = value => {
  if (!value) {
    return true
  }
  if (typeof value === 'string') {
    return true
  }
  return value.size < 2000000
}

export const isValidPhoneNumber = value => {
  if (!value) return true
  const regex = /^(0?)9[0-9]{9}$/
  return regex.test(value)
}

export const isLink = value => {
  const regex = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)/
  if (!value) return true
  return regex.test(value)
}
